<template>
   <div id="wrapper" class="body-font flex w-full flex-col bg-white">
      <div class="grow">
         <SiteNav />

         <!-- Router view (push down 24 which is the same height as the topnav bar) -->
         <!-- style: 100vh - (the height of the topnav otherwise we end up with an extra 5.5rems) -->
         <div
            class="mb-16 mt-24 print:mt-0 h-full overflow-hidden"
            data-info="page-wrapper-view"
            style="min-height: calc(100vh - 5.5rem)"
         >
            <RouterView></RouterView>
         </div>

         <!-- SiteFooter -->
         <SiteFooter v-if="!pageHasMinimalNav" />
      </div>
   </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";

// data
// --------------------------------------
const route = useRoute();

// const store = useStore();
// const smoothScroll: any = inject("smoothScroll");

const routeNamesWithMinimalNav = ["not-found"];

// computed
// -----------------------------------------
const pageHasMinimalNav = computed(() => {
   return routeNamesWithMinimalNav.includes(route.name.toString());
});

// Custom signup link detection
const customSignupRedirect = ref<string | null>(null);
provide("customSignupRedirect", customSignupRedirect);
</script>

<style scoped lang="scss"></style>
